import { AppModuleCode } from '@gb-ticket/shared-types';

import { isModuleEnabled } from '@/platform/auth/permissions';
import { registerProfileSection } from '@/platform/lib/profile-sections';
import { ConnectorPairingCard } from '@/products/helpdesk/features/remote-support/connector-pairing-card';

registerProfileSection({
  id: 'helpdesk.connector-pairing',
  navLabel: 'Fernwartung',
  path: 'fernwartung',
  Component: ConnectorPairingCard,
  isVisible: (user) => isModuleEnabled(user, AppModuleCode.REMOTE_SUPPORT),
});
